import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';
import { ProfileImageDTO, ProfileImageUpdateDTO } from '../../dto/profile-image/profile-image.dto';

@Injectable({
  providedIn: 'root'
})
export class ProfileImageService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getUserProfileImage(uuid: string): Observable<ProfileImageDTO> {
    return this.http.get<ProfileImageDTO>(`${this.apiUrl}/users/${uuid}/profile-image`);
  }

  setUserProfileImage(uuid: string, obfuscatedName: string): Observable<ProfileImageDTO> {
    const body: ProfileImageUpdateDTO = { obfuscated_name: obfuscatedName };
    return this.http.put<ProfileImageDTO>(`${this.apiUrl}/users/${uuid}/profile-image`, body);
  }

  getLocationProfileImage(uuid: string): Observable<ProfileImageDTO> {
    return this.http.get<ProfileImageDTO>(`${this.apiUrl}/locations/${uuid}/profile-image`);
  }

  setLocationProfileImage(uuid: string, obfuscatedName: string): Observable<ProfileImageDTO> {
    const body: ProfileImageUpdateDTO = { obfuscated_name: obfuscatedName };
    return this.http.put<ProfileImageDTO>(`${this.apiUrl}/locations/${uuid}/profile-image`, body);
  }
}
